import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { Helpers } from "src/helpers/helpers";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { PromoCode } from "src/models/promo-code";
import { CreatePromoCodeDto } from "src/dto/request/create-promoCode-dto";
import { UpdatePromoCode } from "src/models/update-promo-code";

@Injectable({
  providedIn: "root",
})
export class SafrattiPromoCodeService extends BaseService {
  constructor(private http: HttpClient, helper: Helpers) {
    super(helper);
  }

  getPromoCode(): Observable<PromoCode[]> {
    return this.http
      .get<PromoCode[]>(
        environment.apiUrl + "Safratti/Promotion",
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  createPromoCode(body: CreatePromoCodeDto): Observable<void> {
    return this.http
      .post<void>(
        environment.apiUrl + "Safratti/Promotion",
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  fetchPromoCode(couponCode: string): Observable<UpdatePromoCode> {
    return this.http
      .get<UpdatePromoCode>(
        environment.apiUrl + `Safratti/Promotion/` + couponCode,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  updatePromoCode(couponCode: string, body: UpdatePromoCode): Observable<void> {
    return this.http
      .put<void>(
        environment.apiUrl + "Safratti/Promotion/" + couponCode,
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  toggleStatus(couponCode: string): Observable<void> {
    return this.http
      .put<void>(
        environment.apiUrl + `Safratti/Promotion/${couponCode}/ToggleStatus`,
        {},
        super.header()
      )
      .pipe(catchError(super.handleError));
  }
}
